<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-non-bodymatter element-container-single element-type-epigraph element-without-heading" epub:type="epigraph" id="epigraph">
<div class="text" id="epigraph-text">
<p class="first first-in-chapter first-full-width">“Chokepoint” is one of several stories I wrote that parallel the events from a novel, in this case <i>two</i> novels—<i>Dead of Night</i> and <i>Fall of Night</i>. Those books are set approximately fifteen years after my Joe Ledger thrillers and fourteen years before my YA post-apocalyptic novel series, Rot &amp; Ruin. This story, however, was intended to be read as a standalone, without requiring that the reader be familiar with the novels.</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// authors-note.vue?1fcad35d